import { Property } from '@/types';
import { dateDiffInDays } from '@/utility/date';

export function getNumberRatio(value: number, max: number): number {
  if (!max) return 0;
  return Math.ceil((value / max) * 100);
}

export function getLandSizeInFt(property: Property): number {
  if (!property.lot) return null;
  if (property.lot.measurement?.toLowerCase() === 'feet') {
    const depth = isNaN(Number(property.lot.depth))
      ? 0
      : Number(property.lot.depth);
    const width = isNaN(Number(property.lot.width))
      ? 0
      : Number(property.lot.width);

    return depth * width;
  }

  return 0;
}

export function isSold(property: Property) {
  return property.lastStatus === 'Sld' || property.lastStatus === 'Lsd';
}

export function soldInDays(property: Property) {
  if (!isSold(property)) return null;
  return Math.max(dateDiffInDays(property.soldDate, property.listDate), 0);
}

export function soldInDaysString(property: Property) {
  const days = soldInDays(property);
  if (days === null) return null;
  return `${days} days`;
}
